import { routerMiddleware } from 'react-router-redux'
import {  browserHistory } from 'react-router'
import { createStore, applyMiddleware, compose } from 'redux'
import { values } from 'lodash'
import thunk from 'redux-thunk'
import promptsMiddleware from '../../app/components/Prompts/promptsMiddleware'
import ActionTypes from '../../app/actions/ActionTypes.js';
import reducer from '../../app/reducers/index'

import users from './data/users.json'
import cities from './data/cities.json'
import trips from './data/trips.json'
import activities from './data/activities.json'
import routes from './data/routes.json'
import blocks from './data/blocks.json'
import expenses from './data/expenses.json'
import suppliers from './data/suppliers.json'
import tasks from './data/tasks.json'

export const initialState = {
  historyCache: {oper: "/private/oper"},
  persistence: {dirty: false},
  loginData: {username: "pruebito"},
  users,
  ui: {
    planTriggers: {}
  },
  cities,
  trips,
  activities,
  routes,
  blocks,
  expenses,
  suppliers,
  tasks
}

const store = createStore(
  reducer,
  initialState,
  compose(
    applyMiddleware(
      thunk,
      routerMiddleware(browserHistory),
      promptsMiddleware,
    )
  )
)

store.dispatch({
  type: ActionTypes.RECEIVE_ALL_TASKS, payload: values(tasks)
})
store.dispatch({
  type: ActionTypes.RECEIVE_ALL_SUPPLIERS, payload: values(suppliers)
})
store.dispatch({
  type: ActionTypes.RECEIVE_ALL_EXPENSES, payload: values(expenses)
})
store.dispatch({
  type: ActionTypes.RECEIVE_ALL_BLOCKS, payload: values(blocks)
})
store.dispatch({
  type: ActionTypes.RECEIVE_ALL_ROUTES, payload: values(routes)
})
store.dispatch({
  type: ActionTypes.RECEIVE_ALL_ACTIVITIES, payload: values(activities)
})
store.dispatch({
  type: ActionTypes.RECEIVE_ALL_TRIPS, payload: values(trips)
})
store.dispatch({
  type: ActionTypes.RECEIVE_ALL_CITIES, payload: values(cities)
})

export default store
